export const contactsData = {
    email: 'manvi.singhal03@gmail.com',
    address: 'SRM Institute of Science and Tehnology, Kattankulathur, Tamil Nadu-603203',

    sheetAPI: 'https://sheetdb.io/api/v1/5pksvzxvobsj2'
}
